module.exports = __webpack_public_path__ + "img/data-item4-3.bc39130.png";